// A feature switched off long ago looks broken when it is needed: Vu watched
// a YouTube video in the side panel and no dots came, because Video graph was
// off in that browser (F7, 2026-10-06). When the side panel reports a video
// and the plugin that would draw it is off, say so once, with a way to turn
// it on. Once per plugin, so a person who wants it off is not nagged.
const WATCHERS = [
  { id: 'omni.video-graph', kinds: ['yt-transcript', 'yt-progress', 'yt-audio'], what: 'this video draws no dots' },
]
const DONE_KEY = 'omni.off-hint.done'

export function offHintFor(msg, store, storage) {
  if (!msg || msg.source !== 'omni-side-panel' || typeof msg.kind !== 'string') return null
  const done = JSON.parse(storage.getItem(DONE_KEY) ?? '[]')
  for (const w of WATCHERS) {
    if (!w.kinds.includes(msg.kind) || done.includes(w.id)) continue
    const entry = store.get(w.id)
    if (!entry || entry.enabled) continue
    storage.setItem(DONE_KEY, JSON.stringify([...done, w.id]))
    return { id: w.id, name: entry.manifest?.name ?? w.id, what: w.what }
  }
  return null
}
